import { SVGProps, Ref, forwardRef } from 'react';

export const ImageHyperstarOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1c9.625 0 11 1.375 11 11s-1.375 11-11 11S1 21.625 1 12q0-1.065.026-2h1.801a68 68 0 0 0-.027 2c0 1.273.025 2.364.086 3.303l5.466-4.455 5.466 4.289 3.653-2.87 3.645 3.01c.06-.932.084-2.015.084-3.277 0-2.392-.088-4.14-.334-5.446-.243-1.289-.608-1.97-1.03-2.39-.42-.422-1.101-.787-2.39-1.03C16.14 2.888 14.392 2.8 12 2.8q-1.085 0-2 .027v-1.8A70 70 0 0 1 12 1M3.13 17.425l.004.021c.243 1.289.608 1.97 1.03 2.39.42.422 1.101.787 2.39 1.03 1.306.246 3.054.334 5.446.334s4.14-.088 5.446-.334c1.289-.243 1.97-.608 2.39-1.03.422-.42.787-1.101 1.03-2.39l.007-.036-3.43-2.832-3.624 2.848-5.446-4.274z"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.5 4.85c.873 0 1.584.301 2.059.87.45.541.591 1.209.591 1.78s-.141 1.239-.591 1.78c-.475.569-1.186.87-2.059.87s-1.584-.301-2.059-.87c-.45-.541-.591-1.209-.591-1.78s.141-1.239.591-1.78c.475-.569 1.186-.87 2.059-.87m0 1.8c-.44 0-.603.136-.676.223-.096.116-.174.323-.174.627s.078.511.174.627c.073.087.236.223.676.223s.603-.136.676-.223c.096-.116.174-.323.174-.627s-.078-.511-.174-.627c-.073-.087-.236-.223-.676-.223"
                    fill="currentColor"
                />
                <path
                    d="M4.5 1A13.3 13.3 0 0 0 8 4.5 13.3 13.3 0 0 0 4.5 8 13.3 13.3 0 0 0 1 4.5 13.3 13.3 0 0 0 4.5 1"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ImageHyperstarOutlinedSize24Glyph.displayName = 'ImageHyperstarOutlinedSize24Glyph';
